import React from "react";
import { useParams, useLocation } from "react-router-dom";
import BootLoadingScreen from "../components/BootLoadingScreen";
import { useCreateBlankContent } from "../http-hooks/content/useCreateBlankContent";
import { useRunOnce } from "../hooks/useRunOnce";

function CreateContent() {
  const { org_id, id } = useParams();
  const location = useLocation();

  const createBlankContent = useCreateBlankContent({ org_id });

  // set default slate value when new content is being created
  useRunOnce(id, () => {
    createBlankContent(id, { audioProfile: location?.state?.audioProfile });
  });

  return <BootLoadingScreen text="Initializing Studio" />;
}

export default CreateContent;
